module.exports = "/static/assets/c2bee5f9ed817c7dee456ad0eae22ae8.gif";